/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-12 13:40:20
 * @FilePath: \heshan_web\src\store\getters.js
 */
var getters = {
  tag: function tag(state) {
    return state.tags.tag;
  },
  language: function language(state) {
    return state.common.language;
  },
  website: function website(state) {
    return state.common.website;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  colorName: function colorName(state) {
    return state.common.colorName;
  },
  themeName: function themeName(state) {
    return state.common.themeName;
  },
  isShade: function isShade(state) {
    return state.common.isShade;
  },
  isCollapse: function isCollapse(state) {
    return state.common.isCollapse;
  },
  keyCollapse: function keyCollapse(state, getters) {
    return getters.screen > 1 ? getters.isCollapse : false;
  },
  screen: function screen(state) {
    return state.common.screen;
  },
  isLock: function isLock(state) {
    return state.common.isLock;
  },
  isFullScren: function isFullScren(state) {
    return state.common.isFullScren;
  },
  isMenu: function isMenu(state) {
    return state.common.isMenu;
  },
  lockPasswd: function lockPasswd(state) {
    return state.common.lockPasswd;
  },
  tagList: function tagList(state) {
    return state.tags.tagList;
  },
  tagWel: function tagWel(state) {
    return state.tags.tagWel;
  },
  token: function token(state) {
    return state.user.token;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission: function permission(state) {
    return state.user.permission;
  },
  menu: function menu(state) {
    return state.user.menu;
  },
  menuId: function menuId(state) {
    return state.user.menuId;
  },
  menuAll: function menuAll(state) {
    return state.user.menuAll;
  },
  waylist: function waylist(state) {
    return state.user.waylist;
  },
  logsList: function logsList(state) {
    return state.logs.logsList;
  },
  stationObj: function stationObj(state) {
    return state.user.stationObj;
  },
  tenantId: function tenantId(state) {
    return state.user.tenantId;
  },
  logsLen: function logsLen(state) {
    return state.logs.logsList.length || 0;
  },
  logsFlag: function logsFlag(state, getters) {
    return getters.logsLen === 0;
  },
  flowRoutes: function flowRoutes(state) {
    return state.dict.flowRoutes;
  }
};
export default getters;